import { BUSINESS_LINES, CouponCardImpressionPayload } from "@swiggy-private/core-types";
import type { COUPON_GROUP_TYPES } from "@swiggy-private/core-types";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import type { ICustomWidgetTypeProps } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import { ActionType } from "@swiggy-private/dls-web-recipe-common-web/dist/components/CouponCard/types";
import {
    GiftingOffersContextPayload,
    GiftingSavingsContextPayload,
    GiftingAppliedCouponContextPayload,
    GiftingPopupContextPayload,
} from "./Gifting";

export { COUPON_GROUP_TYPES } from "@swiggy-private/core-types";

export enum CouponListingPLWidgetTypes {
    COUPON_CARD = "type.googleapis.com/swiggy.gandalf.widgets.v2.CouponSection",
    COUPON_TEXT_BANNER = "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBanner",
    COUPON_SECTION_COMMS = "type.googleapis.com/swiggy.gandalf.widgets.v2.CouponSectionComms",
}

export interface RibbonUIMetaData {
    asset: {
        icon: string;
        height: number;
        width: number;
    };
    backgroundColor: string;
    textColor: keyof IColors;
}

export enum OfferCardType {
    OFFER_CARD_TYPE_POCKET_HERO = "OFFER_CARD_TYPE_POCKET_HERO",
    OFFER_CARD_TYPE_MAX_SAVINGS = "OFFER_CARD_TYPE_MAX_SAVINGS",
}

export enum CouponTagIdentifiers {
    IPL_SUPER_SIX_OFFER = "SUPER_SIX_OFFER",
}
export interface CouponTimer {
    text: string;
    endTimeEpochInSec: string | number;
    backgroundColor: string;
    textColor: keyof IColors;
}

export interface OfferTag {
    offerTag: string;
    textColor?: string;
    backgroundColor?: string;
}
export interface TnCInfo {
    title: string;
    bulletTexts?: string[];
}

export interface BenefitsInfoList {
    title: string;
    description?: string;
}
export interface BenefitsInfo {
    header?: string;
    benefitsList?: BenefitsInfoList[];
}

export interface CouponInfo {
    id?: string;
    applicable: boolean;
    title?: string;
    subtitle?: string;
    emphasisedSubtitle?: string;
    description?: string;
    logo?: string;
    ribbonText?: string;
    ribbonUiMeta?: RibbonUIMetaData;
    tagIdentifiers: CouponTagIdentifiers[];
    titleTimer?: CouponTimer;
    validityText?: string;
    offerTag?: OfferTag;
    tnc?: TnCInfo;
    benefitsInfo?: BenefitsInfo;
    ctaText?: string;
    couponType?: string;
    businessLine?: BUSINESS_LINES;
    absoluteSavings?: number;
    isSelected?: boolean;
    isBestCoupon?: boolean;
    isCouponLessCard?: boolean;
}

export interface INextBestCoupon {
    type: COUPON_GROUP_TYPES;
    coupon: CouponInfo;
}
export enum CouponConfetti {
    INVALID = 0,
    TOP_UP = 1,
    AUTO_APPLY = 2,
}
export interface ICouponCardBanner {
    text: string;
    textColor: string;
    borderColor: string;
    bgColor: string[];
}

export interface IMetaInfo {
    maxCouponSelectionAllowedPerSection: number;
    couponSelectionStyle: ActionType;
    footerImage?: {
        assetId?: string;
        aspectRatio?: number;
    };
}

export interface ICouponCard extends ICustomWidgetTypeProps {
    "@type": CouponListingPLWidgetTypes.COUPON_CARD;
    title: string;
    type: COUPON_GROUP_TYPES;
    coupons?: CouponInfo[];
    message?: ICouponCardBanner;
    newSectionIndicator?: boolean;
    metaInfo?: IMetaInfo;
}

export interface ICouponCardTextBanner extends ICustomWidgetTypeProps {
    "@type": CouponListingPLWidgetTypes.COUPON_TEXT_BANNER;
    id?: string;
    widgetId?: string;
    text?: {
        title?: string;
    };
    bgColour?: string;
    iconUrl?: string;
}

export interface ICouponCards {
    card: { card: ICouponCard };
}

export interface CouponMessageCard {
    icon: string;
    title: string;
    subtitle?: string;
    subtitleColor?: string;
    text?: string; // To be future-deprecated and replaced by: primarySavingsInfo
    subtext?: string; // To be future-deprecated and replaced by: primarySavingsInfo
    attributeValues?: Record<string, string>;
    description: string;
    confetti?: CouponConfetti;
    cta: {
        text: string;
        color: string;
    };
    secondaryDiscountCallout?: string; // To be future-deprecated and replaced by: secondarySavingsInfo
    /* TODO:
     * the following structure is same as having text and subtext,
     * but adding support so that text and subtext can be deprecated in future
     */

    primarySavingsInfo?: {
        text: string;
        subtext: string;
    };
    secondarySavingsInfo?: {
        text: string;
        subtext: string;
    };

    disclaimer?: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    offer_card_type?: OfferCardType;
}

export interface GiftingCouponAnalytics {
    handleImpressionOffers: (payload: GiftingOffersContextPayload) => void;
    handleCouponOffersImpression: (payload: CouponCardImpressionPayload) => void;
    handleSelectCouponCheckboxClick: (payload: CouponCardImpressionPayload) => void;
    handleDeselectCouponCheckboxClick: (payload: CouponCardImpressionPayload) => void;
    handleApplyCouponImpression: (payload: GiftingSavingsContextPayload) => void;
    handleApplyCouponClick: (payload: GiftingAppliedCouponContextPayload) => void;
    handleSearchBarImpression: (placeholder: string) => void;
    handleApplyInputBoxClick: (couponCode: string) => void;
    handleGiftingModalImpression: (payload: GiftingPopupContextPayload) => void;
    handleGiftingModalCloseClick: (payload: GiftingPopupContextPayload) => void;
    handleGiftingModalCTAClick: (payload: GiftingPopupContextPayload) => void;
}
